import React, { useContext, useEffect, useMemo, useState } from "react";
import CheckListFBYInput from "../../../../../../blocks/FormItems/CheckListFBYInput";
import { Typography } from "antd";
import { softTissueInjuryAreaOptions } from "../../../../Options/systemicExamOptions";
const { Text } = Typography;
const SoftTissueInjury = ({ context, form }) => {
  const { formData } = useContext(context);
  const tissueData =
    formData?.systemic_examination || formData?.examination || formData;
  const initialValues = useMemo(() => tissueData, [tissueData]);
  const [checkboxes, setCheckboxes] = useState([]);

  useEffect(() => {
    const initialCheckboxes = softTissueInjuryAreaOptions.reduce(
      (acc, checkbox) => {
        acc[checkbox.value] =
          initialValues?.soft_tissue_injury?.[checkbox.value] || false; // Initialize all checkboxes based on initialValues
        return acc;
      },
      {}
    );
    setCheckboxes(initialCheckboxes);
  }, [initialValues]);

  return (
    <>
      <Text>Soft Tissue Injury</Text>
      <CheckListFBYInput
        options={softTissueInjuryAreaOptions}
        setCheckboxes={setCheckboxes}
        checkboxes={checkboxes}
        keyChain="soft_tissue_injury"
        others_key={"others"}
        form={form}
        field_key={["soft_tissue_injury", "others"]}
      />
    </>
  );
};

export default SoftTissueInjury;
